import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { LegendComponent } from "../../../../../common/components/legend_component"
import { LegendItemComponent } from "../../../../../common/components/legend_item_component"
import { LegendIcon } from "../../../../../common/components/legend_icon"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { GenerateEmpreendimentoListaColumns } from "./columns"
import { EmpreendimentoLista } from "../../../domain/models/empreendimento_lista"
import { useEmpreendimentoListaViewModel } from "../../viewModels/empreendimento_lista_view_model"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"


export const Empreendimento_lista = () => {

    const viewModel = useEmpreendimentoListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateEmpreendimentoListaColumns({
            onActionEdit: viewModel.handleEmpreendimentoEdit,
            onActionDelete: viewModel.handleDeleteEmpreendimentoOpenState
        })
    }, [
        viewModel.handleEmpreendimentoEdit,
        viewModel.handleDeleteEmpreendimentoOpenState
    ]);


    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="w-full justify-end flex flex-row gap-2">
                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={viewModel.handleNewEmpreendimento}>
                                    Novo Empreendimento
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>
            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Incorporação
                    </Link>
                    <Typography className="text-primary-green">
                        Cadastro Empreendimento
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white">Empreendimento Lista</h1>
                        <RefreshButton onClick={() => { }} />
                    </div>
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col flex-wrap justify-end">
                                        <LegendComponent>
                                            <LegendItemComponent
                                                icon={<LegendIcon color='green' title='A' />}
                                                label='Ativo' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='red' title='B' />}
                                                label='Bloqueado' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='yellow' title='E' />}
                                                label='Encerrado' />

                                        </LegendComponent>
                                    </div>

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="empreendimento_lista"
                                    disableColumnMenu={false}
                                    getRowId={(row: EmpreendimentoLista) => row.idEmpreendimento}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    rows={viewModel.empreendimentoLista}
                                    rowCount={viewModel.empreendimentoLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }

                <DeleteDialog
                    open={viewModel.openDeleteModal}
                    saving={viewModel.saving}
                    onClose={() => viewModel.handleDeleteEmpreendimentoOpenState(null, false)}
                    title={`Você realmente deseja excluir este item?`}
                    onDelete={viewModel.handleConfirmarDeletarEmpreendimento} />
            </div>
        </>)
}

